export default "/_next/static/images/Google_AI_Studio_2025-12-06T00_24_50.650Z 19-4c0fe147af5fbe117218c3c8efe31cf8.png";